import { Box, Typography } from '@mui/material';
import { CarIcon } from '@phosphor-icons/react';

import { StyledChip } from '@/components/common/StyledChip';
import { TriasHelper } from '@/modules/TriasHelper';
import type { Duration } from '@/modules/api-routing';
import { IndividualTripParamStructure } from '@/modules/api-routing';

interface ResultSummaryProps {
  duration: Duration | undefined;
  arrival?: string;
  distance?: number;
  algorithm?: IndividualTripParamStructure.algorithmType;
  isDetail?: boolean;
}

export function ResultStructureSummary({ duration, arrival, distance, algorithm, isDetail }: ResultSummaryProps) {
  const getChipConfig = () => {
    if (algorithm === IndividualTripParamStructure.algorithmType.BEAUTIFUL) {
      return {
        label: 'PKW · Einsatzkräfte',
        backgroundColor: '#E98A7A',
      };
    }

    if (algorithm === IndividualTripParamStructure.algorithmType.OPTIMAL) {
      return {
        label: 'PKW · Strategie',
        backgroundColor: '#B9D98A',
      };
    }

    return {
      label: 'PKW · Schnellste',
      backgroundColor: '#F4E3A1',
    };
  };

  const chipConfig = getChipConfig();

  return (
    <Box sx={{ cursor: isDetail ? 'default' : 'pointer' }}>
      <Typography variant="h5">{duration ? TriasHelper.formatDuration(duration) : null}</Typography>
      <Typography color="textSecondary" variant="body2">
        Ankunft {arrival ? TriasHelper.formatTimestamp(arrival) : null} · {TriasHelper.formatDistance(distance)}
      </Typography>

      <StyledChip
        icon={<CarIcon size={18} weight="fill" />}
        label={chipConfig.label}
        sx={{
          mt: 1,
          backgroundColor: chipConfig.backgroundColor,
        }}
      />
    </Box>
  );
}
